import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TaskDetailComponent } from './task-detail/task-detail.component';
import { TaskDashboardComponent } from './task-dashboard/task-dashboard.component';
import { TaskComponent } from './task.component';
import { GanttViewComponent } from './gantt-view/gantt-view.component';


const routes: Routes = [
  {
    path: '',
    component: TaskComponent,
    children: [
      {
        path: '',
        component: TaskDashboardComponent
      },
      {
        path: 'gantt',
        component: GanttViewComponent
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class taskRoutingModule { }
